import { Box } from "@mui/material";
import { useState, useEffect } from "react";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";

interface CustomProps {
  imageArray?: string[];
  noImageLayout: any;
  displayImageIndex?: number;
  setDisplayImageIndex?: Function;
  customStyle?: any;
  imageStyle?: any;
}

const CustomImageCarousal = (props: CustomProps) => {
  const [carousalIndex, setCarousalIndex] = useState<number>(0);

  useEffect(() => {
    if (carousalIndex !== props.displayImageIndex) {
      setCarousalIndex(props.displayImageIndex ?? 0);
    }
  }, [props.displayImageIndex]);

  const carousalIndexIncrement = () => {
    if (props.imageArray && carousalIndex !== props.imageArray.length - 1) {
      setCarousalIndex((prevState) => prevState + 1);
      if (props.displayImageIndex !== undefined) {
        props.setDisplayImageIndex?.(props.displayImageIndex! + 1);
      }
    }
  };

  const carousalIndexDecrement = () => {
    if (carousalIndex !== 0) {
      setCarousalIndex((prevState) => prevState - 1);
      if (props.displayImageIndex !== undefined) {
        props.setDisplayImageIndex?.(props.displayImageIndex! - 1);
      }
    }
  };

  return (
    <Box
      sx={{
        position: "relative",
        "& img": {
          width: "100%",
          height: "100%",
        },
      }}
    >
      {props.imageArray &&
        props.imageArray.length > 0 &&
        carousalIndex !== props.imageArray.length - 1 && (
          <Box
            sx={{
              position: "absolute",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "30px",
              width: "30px",
              margin: "0px 5px",
              borderRadius: "100%",
              filter: `drop-shadow(0px 0px 5px #666)`,
              backgroundColor: "#FFFFFF",
              top: "50%",
              right: "0px",
              cursor: "pointer",
            }}
          >
            <NavigateNextIcon onClick={carousalIndexIncrement} />
          </Box>
        )}
      <img
        src={props.imageArray?.[carousalIndex] || props.noImageLayout}
        style={{
          maxHeight: "350px",
          height: "350px",
        }}
        alt="images"
      />
      {props.imageArray &&
        props.imageArray.length > 0 &&
        carousalIndex !== 0 && (
          <Box
            sx={{
              position: "absolute",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "30px",
              width: "30px",
              margin: "0px 5px",
              borderRadius: "100%",
              filter: `drop-shadow(0px 0px 5px #666)`,
              backgroundColor: "#FFFFFF",
              top: "50%",
              left: "0px",
              cursor: "pointer",
            }}
          >
            <NavigateBeforeIcon
              onClick={carousalIndexDecrement}
              //   sx={classes.arrowIcons}
            />
          </Box>
        )}
    </Box>
  );
};

export default CustomImageCarousal;
